import React from 'react';
import { CellFloat, TableSubSimple } from '../../../../../motion-components';
import { AggregationTableProps } from './types';
import { useTranslation } from 'react-i18next';
import { formatQty } from 'shared-pages/common/number-helpfunc';

export const AggregationTable: React.FC<AggregationTableProps> = ({
  data,
  xLabel,
  measure,
  showTotal = false,
}) => {
  const { t } = useTranslation();
  // Define columns: X dimension + Y value
  const columns = React.useMemo(() => {
    return [
      {
        Header: xLabel,
        accessor: 'xValueName',
        Cell: ({ value }) => <div className="font-weight-bold">{value}</div>,
      },
      {
        Header: `${measure.label} (${measure.unit})`,
        accessor: 'yValue',
        // Cell: ({ value }) => {
        //   const n = Number(value) || 0;
        //   // const formatted = measure.digits !== undefined ? n.toFixed(measure.digits) : String(n);
        //   const formatted = formatQty(n, measure.digits ?? 2);
        //   return <div className="text-right">{formatted}</div>;
        // },
        Cell: CellFloat(),
      },
    ];
  }, [xLabel, measure]);

  // numeric + total
  const numeric = React.useMemo(
    () => (data ?? []).map((d) => ({ ...d, yValue: Number(d.yValue) || 0 })),
    [data],
  );
  const total = React.useMemo(() => numeric.reduce((s, i) => s + i.yValue, 0), [numeric]);
  const displayData = React.useMemo(
    () =>
      showTotal
        ? [...numeric, { xValueId: 'TOTAL', xValueName: t('Σύνολο'), yValue: total }]
        : numeric,
    [numeric, showTotal, total, t],
  );

  return (
    <div className="aggregation-table">
      <TableSubSimple
        columns={columns}
        data={displayData}
        style={{ fontSize: '0.9rem' }}
        rowProps={(row) => (row.original.xValueId === 'TOTAL' ? { className: 'row-total' } : {})}
      />
    </div>
  );
};
